import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            {/* Footer uses light logo variant */}
            <Logo variant="light" />
            <p className="mt-4 text-sm">
              Premium automotive e-commerce platform. Buy your next vehicle with
              confidence through our transparent, hassle-free process.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/vehicles"
                  className="hover:text-white transition-colors"
                >
                  Browse Vehicles
                </Link>
              </li>
              <li>
                <Link
                  to="/brands/compare"
                  className="hover:text-white transition-colors"
                >
                  Compare
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-white transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/financing"
                  className="hover:text-white transition-colors"
                >
                  Financing
                </Link>
              </li>
              <li>
                <Link
                  to="/trade-in"
                  className="hover:text-white transition-colors"
                >
                  Trade-In
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-white mb-4">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>1-877-BES-7679</li>
              <li>
                <a
                  href="mailto:support@bespokianauto.com"
                  className="hover:text-white transition-colors"
                >
                  support@bespokianauto.com
                </a>
              </li>
              <li>Mon-Fri: 9AM-6PM EST</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>
            &copy; {new Date().getFullYear()} Bespokian Auto. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
